module.exports = __webpack_public_path__ + "static/media/PEMS_logo.9ee39ea8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/PEMS_logo.png
// module id = 707
// module chunks = 0